import React from 'react';
import { Hero } from '../components/sections/Hero';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { SpecStatsSection } from '../components/sections/SpecStatsSection';
import { ProcessSection } from '../components/sections/ProcessSection';
import { FaqSection } from '../components/sections/FaqSection';
import { ContactBand } from '../components/sections/ContactBand';
export function Home() {
  return <>
      <Hero data-id="element-334" data-mp="29gdaod6y3u7a" />
      <ProblemSection data-id="element-335" data-mp="29fvibrnem04n" />
      <SolutionSection data-id="element-336" data-mp="29fc1yfdejjsq" />
      <BenefitsSection data-id="element-337" data-mp="29i7xxy5ovyej" />
      <SpecStatsSection data-id="element-338" data-mp="2dhqfcjyaxrcm" />
      <ProcessSection data-id="element-339" data-mp="2dhyu6hdzj6qg" />
      <FaqSection data-id="element-340" data-mp="2dj9ziln2wmjo" />
      <ContactBand data-id="element-341" data-mp="2dfm41gy2pq2b" />
    </>;
}